// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3IhT1"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.scss
// module id = /Umn
// module chunks = 13